import { get } from "lodash";
import { useState, useEffect } from "react";
import { handleError } from "src/handle-error.helper";

function useFetcher() {
  const [service, setService] = useState();
  useEffect(() => {
    (process.env.ESM_BUILD === "true"
      ? import("@canopytax/fetcher")
      : SystemJS.import("fetcher!sofe")
    ).then((s) => setService(s));
  }, []);

  return service;
}

export function useAgreeToVersions(user, onCompleted) {
  const [saving, setSaving] = useState(false);
  const [pendingSave, setPendingSave] = useState();
  const fetcher = useFetcher();

  useEffect(() => {
    if (user.id && fetcher && pendingSave) {
      const existingAgreements = get(user, "legal_agreements", []);
      const newAgreements = [...existingAgreements, ...pendingSave];

      setSaving(true);
      const req = fetcher
        .fetchAsObservable(`/wg/users/${user.id}`, {
          method: "PATCH",
          body: {
            users: {
              legal_agreements: newAgreements,
            },
          },
        })
        .subscribe(
          () => {
            // Update the user object immediately so the observable sees the new state
            user.legal_agreements = newAgreements;

            onCompleted();
            setSaving(false);
            setPendingSave();
          },
          (err) => {
            setSaving(false);
            handleError(err);
          },
        );

      return () => {
        req.unsubscribe();
      };
    }
  }, [user.id, pendingSave, fetcher]); // eslint-disable-line react-hooks/exhaustive-deps
  // lint-td: has missing dependencies: 'onCompleted' and 'user'

  return [saving, setPendingSave];
}
